import React from "react";

import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import { RoundTripTypeEnum } from "@/constants";
import usePlatform from "@/hooks/usePlatform";
import useSearchQuery from "@/hooks/useSearchQuery";

const FilterRoundTrip = (props: {
  value: RoundTripTypeEnum;
  onChange: (value: RoundTripTypeEnum) => void;
}) => {
  const { isPc } = usePlatform();

  const { query } = useSearchQuery();

  const handleChange = (event: React.MouseEvent<HTMLElement>, value: number) => {
    if (value) {
      props.onChange(value);
    }
  };

  const fromLocation = query.fromLocation.map((item) => item.iata);
  const toLocation = query.toLocation.map((item) => item.iata);

  const fromText =
    fromLocation[0] + (fromLocation.length > 1 ? ` +${fromLocation.length - 1}` : "");
  const toText = toLocation[0] + (toLocation.length > 1 ? ` +${toLocation.length - 1}` : "");

  return (
    <ToggleButtonGroup
      color="primary"
      value={props.value}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      size="small"
      className="mt-[15px]"
      sx={
        isPc
          ? {
              width: "560px",
            }
          : {
              width: "100%",
              display: "flex",
            }
      }
    >
      <ToggleButton
        value={RoundTripTypeEnum.Outbound}
        sx={{
          borderTopLeftRadius: "30px",
          borderBottomLeftRadius: "30px",
          flex: 1,
        }}
      >
        <div className="flex items-center px-[20px]">
          <FlightTakeoffIcon sx={{ fontSize: "18px" }} className="mr-[10px]" />
          {isPc ? `Outbound: ${fromText} - ${toText}` : "Outbound"}
        </div>
      </ToggleButton>
      <ToggleButton
        value={RoundTripTypeEnum.Return}
        sx={{
          borderTopRightRadius: "30px",
          borderBottomRightRadius: "30px",
          flex: 1,
        }}
      >
        <div className="flex items-center px-[20px]">
          <FlightLandIcon sx={{ fontSize: "18px" }} className="mr-[10px]" />
          {isPc ? `Return: ${toText} - ${fromText}` : "Return"}
        </div>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default FilterRoundTrip;
